import type { BackToSchool2026SaleVariant } from '../constants/back-to-school-2026-sale';

/**
 * CONENG-2593 Back to School 2026 sitewide sale variants map to Sanity `promotionId` values
 * (currency-restricted in CMS). Gate on `promotionId` — never on `promoCode`, which is the
 * mutable Braavos coupon at checkout.
 *
 * G1 (`bts50`/`BTS50`) — full-price markets, 50% off. G2 (`bts10`/`BTS10`) — low-price markets.
 */
export const BTS_2026_G1_PROMOTION_ID = 'bts50';
export const BTS_2026_G2_PROMOTION_ID = 'bts10';

export function getBts2026SaleVariant(promotionId: string | null | undefined): BackToSchool2026SaleVariant | null {
  if (promotionId === BTS_2026_G1_PROMOTION_ID) {
    return 'g1';
  }
  if (promotionId === BTS_2026_G2_PROMOTION_ID) {
    return 'g2';
  }
  return null;
}

export function getBts2026SaleSlideKey(variant: BackToSchool2026SaleVariant): string {
  return `back-to-school-2026-${variant}`;
}

/** `?force_promo=<promotionId>` wins over the live `usePromotion` response (preview QA only). */
export function resolveBts2026SaleVariant(
  forcedPromotionId: string | null | undefined,
  promotionId: string | null | undefined
): BackToSchool2026SaleVariant | null {
  return getBts2026SaleVariant(forcedPromotionId) ?? getBts2026SaleVariant(promotionId);
}
